export default {
  public: [
    {
      path: 'hakka-order-read-by-code',
      name: 'hakka-order-read-by-code',
      component: () => import('modules/base/views/public/hakkaOrderReadByCode.vue'),
    },
    {
      path: 'webview-login',
      name: 'webview-login',
      component: () => import('modules/member/views/public/webviewLogin.vue'),
    },
  ],
  member: [
    {
      path: 'notification',
      name: 'member.notification',
      component: () => import('modules/member/views/member/notification/notification.vue'),
    },
    {
      path: 'notification-detail/:type/:id',
      name: 'member.notification-detail',
      component: () => import('modules/member/views/member/notification/notificationDetail.vue'),
    },
    {
      path: 'profile',
      name: 'member.profile',
      component: () => import('modules/member/views/member/profile.vue'),
    },
    {
      path: 'favorite',
      name: 'member.favorite',
      component: () => import('modules/member/views/member/favorite.vue'),
    },
    {
      path: 'watch-history',
      name: 'member.watchHistory',
      component: () => import('modules/member/views/member/watchHistory.vue'),
    },
    {
      path: 'line-connect-return',
      name: 'member.line-connect-return',
      component: () => import('modules/member/views/member/lineConnectReturn.vue'),
    },
    {
      path: 'customer-service-list',
      name: 'member.customer-service-list',
      component: () => import('modules/member/views/member/customServiceList.vue'),
    },
    {
      path: 'customer-service/:id',
      name: 'member.customer-service-detail',
      component: () => import('modules/member/views/member/customServiceDetail.vue'),
    },
    // 需要驗證身份
    {
      path: 'reset-password',
      name: 'member.console-reset-password',
      meta: {
        verify: true,
      },
      component: () => import('modules/member/views/member/resetPassword.vue'),
    },
    // 不須驗證身份
    {
      path: 'forgot-password',
      name: 'member.console-forgot-password',
      component: () => import('modules/member/views/member/resetPassword.vue'),
    },
    {
      path: 'webview-debug',
      name: 'webview.debug',
      component: () => import('modules/member/views/public/webviewDebug.vue'),
    },
    {
      path: 'hakka-order/:id?',
      name: 'member.hakka-order',
      component: () => import('modules/member/views/public/hakkaOrder.vue'),
    },
  ],
  unauthorizedMember: [
    {
      path: 'register',
      name: 'member.register',
      component: () => import('modules/member/views/public/register.vue'),
    },
    {
      path: 'login',
      name: 'member.login',
      component: () => import('modules/member/views/public/login.vue'),
    },
    // oauth apple驗證完後導向前端位置
    {
      path: 'oauth-apple-return',
      name: 'member.oauth-apple-return',
      component: () => import('modules/member/views/public/oauthAppleReturn.vue'),
    },
    {
      path: 'oauth-return/:service',
      name: 'member.oauth-return',
      component: () => import('modules/member/views/public/oauthReturn.vue'),
    },
    {
      path: 'resend-verify-mail',
      name: 'member.resend-verify-mail',
      component: () => import('modules/member/views/public/resendVerifyMail.vue'),
    },
    {
      path: 'forgot-password',
      name: 'member.reset-password',
      component: () => import('modules/member/views/public/forgotPassword.vue'),
    },
    {
      path: 'verify-code',
      name: 'member.login-by-verify-code',
      component: () => import('modules/member/views/public/loginByVerifyCode.vue'),
    },
    {
      path: 'webview-debug',
      name: 'webview.debug.member',
      component: () => import('modules/member/views/public/webviewDebug.vue'),
    },
  ],
  unauthorizedAdmin: [],
  admin: [
    {
      path: 'member-trashed',
      name: 'admin.member-trashed-list',
      component: () => import('modules/member/views/admin/memberTrashedList.vue'),
    },
    {
      path: 'member',
      name: 'admin.member-list',
      component: () => import('modules/member/views/admin/memberList.vue'),
    },
    {
      path: 'member/create',
      name: 'admin.member-create',
      meta: {
        mode: 'create',
      },
      component: () => import('modules/member/views/admin/memberForm.vue'),
    },
    {
      path: 'member/update/:id',
      name: 'admin.member-update',
      meta: {
        mode: 'update',
      },
      component: () => import('modules/member/views/admin/memberForm.vue'),
    },
    {
      path: 'member/view/:id',
      name: 'admin.member-view',
      component: () => import('modules/member/views/admin/memberView.vue'),
    },

    // 重設密碼
    {
      path: 'member/reset-password/:id',
      name: 'admin.member.reset-password',
      component: () => import('modules/member/views/admin/resetPassword.vue'),
      meta: {
        mode: 'update',
      },
    },

    // 會員設定
    {
      path: 'config/member',
      name: 'admin.config.member',
      component: () => import('modules/member/views/admin/memberConfigForm/memberConfigForm.vue'),
      meta: {
        mode: 'update',
      },
    },

    {
      path: 'config/customer-service',
      name: 'admin.config.customer-service',
      component: () => import('modules/member/views/admin/customerServiceConfigForm/customerServiceConfigForm.vue'),
      meta: {
        mode: 'update',
      },
    },

    {
      path: 'config/representation',
      name: 'admin.config.representation',
      component: () => import('modules/member/views/admin/representationConfigForm/representationConfigForm.vue'),
      meta: {
        mode: 'update',
      },
    },

    {
      path: 'config/visit',
      name: 'admin.config.visit',
      component: () => import('modules/member/views/admin/visitConfigForm/visitConfigForm.vue'),
      meta: {
        mode: 'update',
      },
    },

    {
      path: 'config/order-notification',
      name: 'admin.config.order-notification',
      component: () => import('modules/member/views/admin/orderConfigForm/orderConfigForm.vue'),
      meta: {
        mode: 'update',
      },
    },

    // 申訴
    {
      path: 'representation',
      name: 'admin.representation-list',
      component: () => import('modules/member/views/admin/representationList.vue'),
    },
    {
      path: 'representation/create',
      name: 'admin.representation-create',
      meta: {
        mode: 'create',
      },
      component: () => import('modules/member/views/admin/representationForm.vue'),
    },
    {
      path: 'representation/update/:id',
      name: 'admin.representation-update',
      meta: {
        mode: 'update',
      },
      component: () => import('modules/member/views/admin/representationForm.vue'),
    },

    // 參訪
    {
      path: 'visit-schedule',
      name: 'admin.visit-schedule',
      component: () => import('modules/member/views/admin/visitSchedule.vue'),
    },
    {
      path: 'visit',
      name: 'admin.visit-list',
      component: () => import('modules/member/views/admin/visitList.vue'),
    },
    {
      path: 'visit/update/:id',
      name: 'admin.visit-update',
      meta: {
        mode: 'update',
      },
      component: () => import('modules/member/views/admin/visitForm.vue'),
    },

    // 推播
    {
      path: 'push',
      name: 'admin.push-list',
      component: () => import('modules/member/views/admin/pushList.vue'),
    },
    {
      path: 'push/create',
      name: 'admin.push-create',
      meta: {
        mode: 'create',
      },
      component: () => import('modules/member/views/admin/pushForm.vue'),
    },
    {
      path: 'push/update/:id',
      name: 'admin.push-update',
      meta: {
        mode: 'update',
      },
      component: () => import('modules/member/views/admin/pushForm.vue'),
    },

    // 客服紀錄
    {
      path: 'customer-service',
      name: 'admin.customer-service-list',
      component: () => import('modules/member/views/admin/customerServiceList.vue'),
    },
    {
      path: 'customer-service/create',
      name: 'admin.customer-service-create',
      meta: {
        mode: 'create',
      },
      component: () => import('modules/member/views/admin/customerServiceCreateForm.vue'),
    },
    {
      path: 'customer-service/update/:id',
      name: 'admin.customer-service-update',
      meta: {
        mode: 'update',
      },
      component: () => import('modules/member/views/admin/customerServiceForm.vue'),
    },

    {
      path: 'customer-service-faq',
      name: 'admin.customer-service-faq-list',
      component: () => import('modules/member/views/admin/customerServiceFaqList.vue'),
    },
    {
      path: 'customer-service-faq/create',
      name: 'admin.customer-service-faq-create',
      meta: {
        mode: 'create',
      },
      component: () => import('modules/member/views/admin/customerServiceFaqForm.vue'),
    },
    {
      path: 'customer-service-faq/update/:id',
      name: 'admin.customer-service-faq-update',
      meta: {
        mode: 'update',
      },
      component: () => import('modules/member/views/admin/customerServiceFaqForm.vue'),
    },
  ],
}